export class MonitorSlaChangeEvent {
    event: any ;
    category1Id : number ;
    category2Id : number ;
    category3Id : number ;
    activityId : number ;
}